var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoDiscordWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000097489499807738137370000013053503045047006336_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000053531645057646165170000003758283786666892434_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.2,25c-11.5-8.6-22.4-8.3-22.4-8.3l-1.1,1.3C75.3,22,81.6,28,81.6,28C62.1,17.3,37.3,17.3,17,28 c0,0,6.6-6.3,21-10.4l-0.8-1c0,0-10.9-0.2-22.4,8.3c0,0-11.5,20.8-11.5,46.3c0,0,6.7,11.5,24.4,12.1c0,0,3-3.5,5.4-6.6 c-10.2-3-14-9.4-14-9.4c6.4,4,12.9,6.5,20.9,8.1c13.1,2.7,29.4-0.1,41.6-8.1c0,0-4,6.5-14.5,9.5c2.4,3,5.3,6.4,5.3,6.4 c17.7-0.6,24.4-12.1,24.4-12C96.8,45.7,85.2,25,85.2,25z M35.1,63.8c-4.5,0-8.2-3.9-8.2-8.8c0.3-11.7,16.1-11.7,16.3,0 C43.2,59.9,39.6,63.8,35.1,63.8z M64.3,63.8c-4.5,0-8.2-3.9-8.2-8.8c0.4-11.7,15.9-11.7,16.3,0C72.5,59.9,68.9,63.8,64.3,63.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDiscordWhite);
export default __webpack_public_path__ + "static/media/logo-discord-white.a1cca63407afe4d34792cb9c660fc815.svg";
export { ForwardRef as ReactComponent };